<template>
  <div class="h-full flex items-center">
    <label class="flex items-center cursor-pointer">
      <input
        v-model="imageMode"
        type="checkbox"
        class="mr-2"
        @change="onToggleChanged"
      />
      <span class="text-gray-darkest text">
        {{ $t('brand-surveys.answers.image-view') }}
      </span>
    </label>
  </div>
</template>

<script>
export default {
  name: 'SurveyImageToggleFilter',
  data() {
    return {
      imageMode: false,
    };
  },
  methods: {
    onToggleChanged() {
      if (this.params.api && this.params.column) {
        this.params.column.colDef.cellRendererParams = {
          ...this.params.column.colDef.cellRendererParams,
          imageMode: this.imageMode,
        };

        this.params.api.refreshCells({
          columns: [this.params.column.colId],
          force: true,
        });
      }
    },

    onFloatingFilterChanged() {},
  },
};
</script>

<style lang="scss" scoped>
.text {
  font-size: 11px;
}
</style>
